import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateCrewTypesRequestErrorProps } from './types';
import { SaveCrewTypeSelectionError } from '@bechtel/types';

const getErrorMessage = (error: UpdateCrewTypesRequestErrorProps['updateCrewTypesError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  } else if (error == SaveCrewTypeSelectionError.INVALID_CREW_TYPE_PROVIDED)
    return <Trans>Invalid Crew Type provided.</Trans>;
};

const UpdateCrewTypesRequestErrorModal: FC<UpdateCrewTypesRequestErrorProps> = ({ updateCrewTypesError, close }) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="update-crew-types-request-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Update Crew Types Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updateCrewTypesError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
export default UpdateCrewTypesRequestErrorModal;
